import React, { useEffect, useState } from 'react';
import DataTable from '../../../Pages/InputField/TableLayout';
import { Button, Row, Col } from 'react-bootstrap';
import baseURL from '../../../../Url/NodeBaseURL';
import * as XLSX from 'xlsx';
import { FaFileExcel } from 'react-icons/fa';


const StockReport = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const columns = React.useMemo(
        () => [
            {
                Header: 'Sr. No.',
                Cell: ({ row }) => row.index + 1, 
            },
            { Header: 'Category Name', accessor: 'product_name' },
            { Header: 'Barcode', accessor: 'rbarcode' },
            { Header: 'Metal Type', accessor: 'Category' },
            { Header: 'Pur Qty', accessor: 'pur_qty' },
            { Header: 'Pur Weight', accessor: 'pur_weight' },
            { Header: 'Sale Qty', accessor: 'sale_qty' },
            { Header: 'Sale Weight', accessor: 'sale_weight' },
            { Header: 'Bal Qty', accessor: 'bal_qty' },
            { Header: 'Bal Weight', accessor: 'bal_weight' },
        ],
        []
    );

    const downloadExcel = () => {
        // Prepare data for Excel export
        const excelData = data.map((item, index) => ({
            'Sr. No.': index + 1,
            'Category Name': item.product_name || '',
            'Barcode': item.rbarcode || '',
            'Metal Type': item.Category || '',
            'Pur Qty': item.pur_qty || 0,
            'Pur Weight': item.pur_weight || 0,
            'Sale Qty': item.sale_qty || 0,
            'Sale Weight': item.sale_weight || 0,
            'Bal Qty': item.bal_qty || 0,
            'Bal Weight': item.bal_weight || 0,
        }));

        // Create worksheet and workbook
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Stock Report');

        // Generate Excel file and trigger download
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Stock_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch(`${baseURL}/get/products`);
                if (!response.ok) {
                    throw new Error('Failed to fetch products');
                }
                const result = await response.json();
                setData(result);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    return (
        <div className="main-container">
            <div className="payments-table-container">
                <Row className="mb-3">
                    <Col className="d-flex justify-content-between align-items-center">
                        <h3>Stock Report</h3>
                        <Button 
                            variant="success" 
                            onClick={downloadExcel}
                            disabled={loading || data.length === 0}
                            className="d-flex align-items-center gap-2"
                        >
                           <FaFileExcel />
                            Download Excel
                        </Button>
                    </Col>
                </Row>
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <DataTable columns={columns} data={[...data].reverse()} />
                )}
            </div>
        </div>
    );
};

export default StockReport;